<div class="box-form-ui container contact-information">
  <h2>Indícanos dónde vives</h2>
  <form
    id="FormContactInformation"
    class="form-contact-information"
    [formGroup]="contactInformationForm"
    autocomplete="off"
    (ngSubmit)="onSubmit()"
  >
    <div formGroupName="addressGroup" class="address-group">
      <mat-form-field appearance="fill">
        <mat-label class="label" *ngIf="!userGroupDisabled">Ciudad</mat-label>
        <mat-label class="disabled-label" *ngIf="userGroupDisabled"
          >Ciudad</mat-label
        >
        <input
          matInput
          type="text"
          formControlName="homeCity"
          [matAutocomplete]="auto"
          maxlength="50"
          id="HomeCity"
          #homeCity
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          [displayWith]="homeCityDisplayFn"
          (closed)="closedEmitter(controlHomeCity, 'homeCity')"
        >
          <mat-option
            *ngFor="let option of filteredHomeCities | async"
            [value]="option"
          >
            {{ option.name }}
          </mat-option>
        </mat-autocomplete>

        <mat-error
          *ngIf="
            contactInformationForm
              .get('addressGroup.homeCity')!
              .hasError('required')
          "
        >
          Este campo es obligatorio.
        </mat-error>

        <mat-error
          *ngIf="
            !contactInformationForm
              .get('addressGroup.homeCity')!
              .hasError('required') &&
            contactInformationForm
              .get('addressGroup.homeCity')!
              .hasError('isString')
          "
        >
          En esta ciudad no tenemos cobertura.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" class="home-district">
        <mat-label class="label" *ngIf="!userGroupDisabled">Barrio</mat-label>
        <mat-label class="disabled-label" *ngIf="userGroupDisabled"
          >Barrio</mat-label
        >
        <input
          matInput
          appCapitalize
          type="text"
          formControlName="homeDistrict"
          id="HomeDistrict"
          maxlength="50"
          #homeDistrict
        />
        <mat-error
          *ngIf="
            contactInformationForm
              .get('addressGroup.homeDistrict')!
              .hasError('required')
          "
        >
          Este campo es obligatorio.
        </mat-error>

        <mat-error
          *ngIf="
            !contactInformationForm
              .get('addressGroup.homeDistrict')!
              .hasError('required') &&
            contactInformationForm
              .get('addressGroup.homeDistrict')!
              .hasError('minlength')
          "
        >
          Este campo debe tener mínimo 2 caracteres.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label class="label" *ngIf="!userGroupDisabled"
          >Dirección (incluye bloque, apto, etc…)</mat-label
        >
        <mat-label class="disabled-label" *ngIf="userGroupDisabled"
          >Dirección (incluye bloque, apto, etc…)</mat-label
        >
        <input
          appCapitalize
          appAddress
          matInput
          type="text"
          formControlName="homeAddress"
          maxlength="60"
          id="HomeAddress"
          #homeAddress
        />
        <mat-error
        id="HomeAddressRequiredError"
          *ngIf="
            contactInformationForm
              .get('addressGroup.homeAddress')!
              .hasError('required')
          "
        >
          Este campo es obligatorio.
        </mat-error>

        <mat-error
        id="HomeAddressMinLengthError"
          *ngIf="
            !contactInformationForm
              .get('addressGroup.homeAddress')!
              .hasError('required') &&
            contactInformationForm
              .get('addressGroup.homeAddress')!
              .hasError('minlength')
          "
        >
          Este campo debe tener mínimo 5 caracteres.
        </mat-error>
        <mat-error
        id="HomeAddressGeneralError"
          *ngIf="
            !contactInformationForm
              .get('addressGroup.homeAddress')!
              .hasError('required') &&
            !contactInformationForm
              .get('addressGroup.homeAddress')!
              .hasError('minlength') &&
            (contactInformationForm
              .get('addressGroup.homeAddress')!
              .hasError('wordDetected') ||
              contactInformationForm
                .get('addressGroup.homeAddress')!
                .hasError('pattern') ||
              contactInformationForm
              .get('addressGroup.homeAddress')!
              .hasError('lengthAfterFirstWordError')||
              contactInformationForm
              .get('addressGroup.homeAddress')!
              .hasError('tooManyRepeatedChars')||
              contactInformationForm
              .get('addressGroup.homeAddress')!
              .hasError('maxLengthError'))
          "
        >
          La información ingresada no es válida.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" class="home-address">
        <mat-label class="label">
          Teléfono fijo sin indicativo (opcional)
        </mat-label>
        <input
          matInput
          appOnlyNumbers
          type="tel"
          inputmode="numeric"
          formControlName="landlinePhone"
          id="LandlinePhone"
          maxlength="7"
        />
        <mat-error
          *ngIf="
            contactInformationForm
              .get('addressGroup.landlinePhone')!
              .hasError('required')!
          "
        >
          Este campo es obligatorio.
        </mat-error>

        <mat-error
          *ngIf="
            !contactInformationForm
              .get('addressGroup.landlinePhone')!
              .hasError('required') &&
            contactInformationForm
              .get('addressGroup.landlinePhone')!
              .hasError('minlength')
          "
        >
          Este campo debe tener mínimo 7 caracteres.
        </mat-error>

        <mat-error
          *ngIf="
            !contactInformationForm
              .get('addressGroup.landlinePhone')!
              .hasError('required') &&
            contactInformationForm
              .get('addressGroup.landlinePhone')!
              .hasError('maxlength')
          "
        >
          Este campo debe tener máximo 7 caracteres.
        </mat-error>

        <mat-error
          *ngIf="
            !contactInformationForm
              .get('addressGroup.landlinePhone')!
              .hasError('required') &&
            !contactInformationForm
              .get('addressGroup.landlinePhone')!
              .hasError('minlength') &&
            !contactInformationForm
              .get('addressGroup.landlinePhone')!
              .hasError('maxlength') &&
            contactInformationForm
              .get('addressGroup.landlinePhone')!
              .hasError('landline')
          "
        >
          El teléfono que ingresaste no es válido.
        </mat-error>
      </mat-form-field>
    </div>

    <div
      *ngIf="groupWorkplace.enabled"
      formGroupName="workplaceGroup"
      class="work-place-group"
    >
      <h2>Datos de tu lugar de trabajo</h2>

      <mat-form-field appearance="fill">
        <mat-label class="label"> Nombre de la empresa </mat-label>
        <input
          matInput
          appCapitalize
          appCompanyName
          type="text"
          formControlName="companyName"
          id="CompanyName"
          maxlength="40"
        />
        <mat-error
        id="CompanyNameRequiredError"
          *ngIf="
            contactInformationForm
              .get('workplaceGroup.companyName')
              .hasError('required')
          "
        >
          Este campo es obligatorio.
        </mat-error>

        <mat-error
        id="CompanyNameMinLengthError"
          *ngIf="
            !contactInformationForm
              .get('workplaceGroup.companyName')
              .hasError('required') &&
            contactInformationForm
              .get('workplaceGroup.companyName')
              .hasError('minlength')
          "
        >
          Este campo debe tener mínimo 3 caracteres.
        </mat-error>

        <mat-error
        id="companyNameMaxLengthError"
          *ngIf="
            !contactInformationForm
              .get('workplaceGroup.companyName')
              .hasError('required') &&
            !contactInformationForm
              .get('workplaceGroup.companyName')
              .hasError('minlength') &&
            contactInformationForm
              .get('workplaceGroup.companyName')
              .hasError('maxlength')
          "
        >
          Este campo debe tener máximo 40 caracteres.
        </mat-error>
        <mat-error
        id="companyNameMalformedError"
            *ngIf="
              contactInformationForm
                .get('workplaceGroup.companyName')
                .hasError('notAllowedCharactersError') &&
                (
                  contactInformationForm.get('workplaceGroup.companyName')?.touched || 
                  contactInformationForm.get('workplaceGroup.companyName')?.dirty
                )
            "
          >
          La información ingresada no es válida.
          </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label class="label"> Ciudad </mat-label>
        <input
          matInput
          type="text"
          formControlName="workCity"
          [matAutocomplete]="cityAuto"
          maxlength="50"
          id="WorkCity"
        />
        <mat-autocomplete
          #cityAuto="matAutocomplete"
          [displayWith]="workCityDisplayFn"
          (closed)="closedEmitter(controlWorkCity, 'workCity')"
        >
          <mat-option
            *ngFor="let option of filteredWorkCities | async"
            [value]="option"
          >
            {{ option.municipality }}
          </mat-option>
        </mat-autocomplete>

        <mat-error
          *ngIf="
            contactInformationForm
              .get('workplaceGroup.workCity')
              .hasError('required')
          "
        >
          Este campo es obligatorio.
        </mat-error>

        <mat-error
          *ngIf="
            !contactInformationForm
              .get('workplaceGroup.workCity')
              .hasError('required') &&
            contactInformationForm
              .get('workplaceGroup.workCity')
              .hasError('isString')
          "
        >
          Esta ciudad no es válida.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" class="work-phone">
        <mat-label class="label"> Teléfono fijo sin indicativo</mat-label>
        <input
          matInput
          appOnlyNumbers
          type="tel"
          inputmode="numeric"
          formControlName="workPhone"
          id="WorkPhone"
          maxlength="7"
        />
        <mat-error
        id="workPhoneRequiredError"
          *ngIf="
            contactInformationForm
              .get('workplaceGroup.workPhone')
              .hasError('required')
          "
        >
          Este campo es obligatorio.
        </mat-error>

        <mat-error
        id="workPhoneMalformedError"
          *ngIf="
            !contactInformationForm
              .get('workplaceGroup.workPhone')
              .hasError('required') &&
            contactInformationForm
              .get('workplaceGroup.workPhone')
              .hasError('landlineOrMobilePhone')
          "
        >
          El teléfono que ingresaste no es válido.
        </mat-error>
        <mat-error
        id="workPhoneMinLengthError"
            *ngIf="
              contactInformationForm
                .get('workplaceGroup.workPhone')
                .hasError('minlength')
            "
          >
            Este campo debe tener mínimo 7 caracteres.
          </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" class="work-address">
        <mat-label class="label"> Dirección </mat-label>
        <input
          appCapitalize
          appAddress
          matInput
          type="text"
          maxlength="60"
          formControlName="workAddress"
          id="WorkAddress"
        />
        <mat-error
          id="WorkAddressRequiredError"
          *ngIf="
            contactInformationForm
              .get('workplaceGroup.workAddress')
              .hasError('required')
          "
        >
          Este campo es obligatorio.
        </mat-error>

        <mat-error
        id="WorkAddressMinLengthError"
          *ngIf="
            !contactInformationForm
              .get('workplaceGroup.workAddress')
              .hasError('required') &&
            contactInformationForm
              .get('workplaceGroup.workAddress')
              .hasError('minlength')
          "
        >
          Este campo debe tener mínimo 5 caracteres.
        </mat-error>
        <mat-error
        id="WorkAddressGeneralError"
          *ngIf="
            !contactInformationForm
              .get('workplaceGroup.workAddress')
              .hasError('required') &&
            !contactInformationForm
              .get('workplaceGroup.workAddress')
              .hasError('minlength') &&
            (contactInformationForm
              .get('workplaceGroup.workAddress')
              .hasError('wordDetected') ||
              contactInformationForm
                .get('workplaceGroup.workAddress')
                .hasError('pattern') ||
              contactInformationForm
              .get('workplaceGroup.workAddress')!
              .hasError('lengthAfterFirstWordError')||
              contactInformationForm
              .get('workplaceGroup.workAddress')!
              .hasError('tooManyRepeatedChars')||
              contactInformationForm
              .get('workplaceGroup.workAddress')!
              .hasError('maxLengthError'))
          "
        >
          La información ingresada no es válida.
        </mat-error>
      </mat-form-field>
    </div>

    <div class="box-btn-submit">
      <button
        class="btn btn-degraded blue"
        type="submit"
        [disabled]="!contactInformationForm.valid"
        id="SubmitContactInformationForm"
      >
        Continuar
      </button>
    </div>
  </form>
</div>
